// src/components/ActiveSwarmCard/AdditionalInfo.js

import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Avatar, Skeleton } from '@mui/material';
import { getBuyManagerById } from '../../../../../../store/slices/buyManager/buyManagers';
import { useSelector } from 'react-redux';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';

/**
 * AdditionalInfo Component
 * Displays user avatar, purchase statistics, and edit button.
 * 
 * @param {Object} props
 * @param {number} props.completed - Number of purchases made.
 * @param {number} pops.accepted - Number of accepted purchases.
 * @param {id} pops.buyManagerId - Id of the buy manager.
 * @param {boolean} props.isAutoBuyActive - Whether the swarm is using AutoBuy.
 * @returns {JSX.Element}
 */
const AdditionalInfo = ({ completed, accepted, buyManagerId, isAutoBuyActive }) => {

  const buyManager = useSelector(state => getBuyManagerById(state, buyManagerId));
  const avatar = { color: buyManager?.color || '#FFB74D', initials: buyManager?.firstName[0] + buyManager?.lastName[0] }
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '20px', flexWrap: 'nowrap', margin:"2px 0 0 0" }}>
      {/* User Avatar with Tooltip */}
      <Tooltip title={`${buyManager?.firstName} ${buyManager?.lastName}`}>
        <Avatar sx={{
          backgroundColor: avatar?.color,
          height: '20px',
          width: '20px',
          fontSize: '10px',
          fontWeight: '700',
          margin:"0 16px 0 0",
        }}>
          {avatar.initials}
        </Avatar>
      </Tooltip>

      {/* Future Icon for AUTOBUY */}
      <SmartToyOutlinedIcon sx={{margin:"0 16px 0 0", color: isAutoBuyActive ? "green" : "lightgray"}} />

      {/* Purchase Statistics */}
      <div style={{ display: 'flex', alignItems: 'center', fontWeight: 600, width:'100%', justifyContent:'center' }}>
        <span>
          {completed !== undefined ? completed : <Skeleton variant="text" width={10} />}
        </span>
        <span style={{ margin: '0 0.25em' }} >
          /
        </span>
        {/* FOR THE USER PEDING ARE ACCEPTED BUY REQUEST THAT ARE PEDING TO BE Bought */}
        <span>
          {accepted !== undefined ? accepted : <Skeleton variant="text" width={10} />}
        </span>
      </div>

    </div>
  )
}

AdditionalInfo.propTypes = {
  bought: PropTypes.number,
  pending: PropTypes.number,
  isNow: PropTypes.bool.isRequired,
};

export default AdditionalInfo;
